import { render, staticRenderFns } from "./SMSLogs.vue?vue&type=template&id=57c0b6b8&scoped=true"
import script from "./SMSLogs.vue?vue&type=script&lang=js"
export * from "./SMSLogs.vue?vue&type=script&lang=js"
import style0 from "./SMSLogs.vue?vue&type=style&index=0&id=57c0b6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c0b6b8",
  null
  
)

export default component.exports